import { useMemo } from "react";

import * as Repository from "@/components/features/faq/model/repository";
import type * as ModelType from "@/components/features/faq/model/type";

import * as Converter from "./converter";

export const useInitialized = () => {
	const hostServerModel = Repository.Query.useArticleListQuery(Repository.Query.QueryKeys.hostArticleList);
	const guestServerModel = Repository.Query.useArticleListQuery(Repository.Query.QueryKeys.guestArticleList);

	const queryData: ModelType.QueryData = useMemo(
		() => Converter.serverModelToInputModelConverter(hostServerModel, guestServerModel),
		[hostServerModel, guestServerModel],
	);

	return {
		queryData,
	};
};
